// Brazilian Portuguese — partial translation seeded over the English
// catalogue. Every key not overridden here falls back to en.js
// (fallbackLocale) and the spread below keeps the full structure intact.
// Extend section by section; keep keys identical to en.js.
import en from "./en";

export default {
    ...en,
    Projects: {
        ...en.Projects,
        tasks: "Tarefas",
        save: "Salvar",
        cancel: "Cancelar",
        delete: "Excluir",
        status: "Status",
        priority: "Prioridade",
        due_date: "Prazo",
        assignee: "Responsável",
        new_task: "Nova tarefa",
        add_subtask: "Adicionar subtarefa",
        archive: "Arquivar",
        duplicate: "Duplicar",
        group_by: "Agrupar por",
        subtask: "Subtarefa",
        expanded: "Expandido",
        collapsed: "Recolhido",
        me: "Eu",
        burndown: "Burndown",
        select_sprint: "Sprint",
        no_burndown_data: "Ainda não há dados para esta sprint",
        recent_tasks: "Recentes",
        no_recent_tasks: "Nenhuma tarefa visitada recentemente",
        global_search: "Buscar tudo",
        search_everything: "Buscar tarefas, projetos e comentários...",
        no_search_results: "Nada encontrado",
        epics: "Épicos",
        add_epic: "Adicionar",
        epic_name_placeholder: "Nome do novo épico...",
        no_epics: "Ainda não há épicos",
        select_epic: "Adicionar ao épico",
        remove_from_epic: "Remover do épico",
        export_tasks: "Exportar",
        export_preparing: "Exportação iniciada — preparando o arquivo...",
        export_ready: "Exportação pronta — baixando",
        export_failed: "Falha na exportação",
        pages: "Páginas",
        add_page: "Nova",
        no_pages: "Ainda não há páginas",
        select_page: "Selecione ou crie uma página",
        save_page: "Salvar",
        untitled_page: "Página sem título",
        page_versions: "Histórico",
        page_restored: "Versão restaurada",
        edit: "Editar",
        preview: "Pré-visualizar",
        insert_task_chip: "Inserir chip de tarefa",
        search_task: "Buscar tarefa por nome ou chave...",
        no_tasks_found: "Nenhuma tarefa encontrada",
        unknown_status: "Desconhecido",
        public_link: "Link público",
        create_public_link: "Criar link público",
        move_to_folder: "Mover para pasta",
        no_folder_root: "Sem pasta (raiz)",
        select_folder: "Selecione uma pasta para mover este sprint",
        link_enabled: "Link ativado",
        allow_intake: "Aceitar solicitações públicas",
        intake_inbox: "Solicitações",
        no_intake: "Nenhuma solicitação pendente",
        anonymous: "Anônimo",
        accept: "Aceitar",
        reject: "Rejeitar",
        import_jira: "Importar do Jira",
        import_asana: "Importar do Asana",
        import_monday: "Importar do Monday.com",
        importing: "Importando...",
        start_import: "Importar",
        linked_tasks: "Tarefas vinculadas",
        add_link: "Vincular tarefa",
        remove_link: "Remover vínculo",
        no_linked_tasks: "Ainda não há tarefas vinculadas",
        searching: "Buscando...",
        add_reaction: "Adicionar reação",
    },
    Comments: {
        ...en.Comments,
        edit: "Editar",
        reply: "Responder",
        copy_message: "Copiar mensagem",
        more: "Ver mais",
        less: "Ver menos",
        edited: "editado",
    },
    AI: {
        ...en.AI,
        ai_write_description: "Escrever com IA",
        ai_desc_intent_placeholder: "O que esta descrição deve abordar? (opcional)",
        ai_desc_intent_hint: "Deixe em branco para gerar a partir do título.",
        ai_generate: "Gerar",
        ai_regenerate: "Gerar novamente",
        ai_use_this: "Usar esta",
        ai_answer_questions: "Responda algumas perguntas rápidas para que a descrição fique precisa:",
        ai_generating: "Gerando…",
        ai_failed: "Não foi possível gerar uma descrição. Tente novamente.",
    },
};
